module.exports = [{"type":"hash","text":"時間戳規範"},{"type":"normal","text":"","children":[{"type":"html","text":"除非另外指定，API中的所有時間戳均以毫秒為單位返回。"},{"type":"html","text":"請求的時間戳必須在API服務時間的5秒內，否則請求将被视為過期併被拒絕。如果本地服務器時間和API服務器時間之間存在較大的偏差，那麼我们建議您使用通過查詢API服務器時間來更新http header。                "}]},{"type":"html","text":"<h4>例子<h4>"},{"type":"code","text":"1587091154123"}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/swapV2/api/basic/02_timestamp.json
// module id = gE9e
// module chunks = 3